<div class="relative flex justify-center items-center w-full">
    <a
        class="absolute -left-8 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-50 px-3"
        (click)="goToPreviousImage()">
        <fa-icon
            class="text-2xl text-custom-extra-dark-grey"
            [icon]="['fas', 'chevron-left']" />
    </a>

    <div class="flex justify-center w-full px-2">
        <img
            alt="Result photo"
            class="object-contain transition-all duration-500 ease-out"
            [ngClass]="{
                'max-w-[90%] max-h-[70vh]': isLandscape,
                'max-w-[50%] max-h-[80vh]': !isLandscape,
            }"
            [src]="getCurrentImage()"
            (load)="onImageLoad($event)" />
    </div>
    <a
        class="absolute -right-6 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-50 pl-2 pr-5"
        (click)="goToNextImage()">
        <fa-icon
            class="text-2xl text-custom-extra-dark-grey"
            [icon]="['fas', 'chevron-right']" />
    </a>
</div>
